module.exports = __webpack_public_path__ + "static/media/intro.3b0167db.mp3";